import { Icon as AlphaIcon } from '@oneaudi/unified-web-alpha-components';

export default AlphaIcon;
